
import React, {AnchorHTMLAttributes, FC} from 'react';
import {LINK_EXT} from 'constants/index';
import {Link as GatsbyLink} from 'gatsby';
import {SLEvent, smartlook} from 'utils/window/smartlook';

const isRelative = (str: string) => /^[^/]+\/[^/].*$|^\/[^/].*$/.test(str);
const isProtocol = (str: string) => /^(mailto|tel):/.test(str);

type LinkProps = AnchorHTMLAttributes<object> & {
	track?: string
};

export const Link: FC<LinkProps> = ({children, href, track, ...rest}) => {
	const onClick = (!track || !href) ? undefined : () => {
		smartlook.track(SLEvent.LinkClick, {
			source: track,
			target: href,
		});
	};

	if (href && isRelative(href)) {
		return (
			<GatsbyLink to={href} {...rest} onClick={onClick}>
				{children}
			</GatsbyLink>
		);
	}

	let props = {href, ...rest};
	if (href && !isRelative(href) && !isProtocol(href)) {
		props = {...props, ...LINK_EXT()};
	}

	return (
		<a {...props} onClick={onClick}>
			{children}
		</a>
	);
};

export const TrackLink = (track?: string) => {
	if (!track) {
		return Link;
	}
	return function WrappedLink(props: LinkProps) {
		return <Link {...props} track={track} />;
	};
};
